import Loader from "react-loader-spinner";
import momenJalaali from "moment-jalali";
import { faBroom, faEnvelopeOpen } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { EyeFill, EyeSlashFill, Search } from "react-bootstrap-icons";
import { deleteMessage, getMessagePriorityList, getMessageStatusList, searchMessages } from "../store/api/MessagesAPI";
import { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import DatePicker from "react-datepicker2";
import BihamtaTable from "../../Components/BihamtaTable";
import {  setDialog, setErrorDialog, useIsMobileApp } from "../../store/api/CommonFunctions";

const SearchInterOfficeMessages = () => {
    const frmFilters = useRef();
    const history = useHistory();
    const dispatch = useDispatch();
    const isMobile = useIsMobileApp();
    const { handleSubmit, register } = useForm();
    const [showFilter, setShowFilter] = useState(true);
    const [priorityList, setPriorityList] = useState(null);
    const [statusList, setStatusList] = useState(null);
    const filterData = useSelector(state => state.CommonReducer.interOfficeMessageFilters)
    const [dateFilters, setDateFilters] = useState({
        MessageDateFrom: filterData?.MessageDateFrom,
        MessageDateTo: filterData?.MessageDateTo,
        RegisterDateFrom: filterData?.RegisterDateFrom,
        RegisterDateTo: filterData?.RegisterDateTo
    });
    const tableCols = [
        { colTitle: "ردیف", colName: "RowNumber", showInMobile: true },
        {colTitle:"نوع نامه", colName:"PMessageType"},
        { colTitle: "موضوع نامه", colName: "Subject", showInMobile: true },
        { colTitle: "تاریخ نامه", colName: "PMessageDate", showInMobile: true },
        { colTitle: "شماره نامه", colName: "RealNumber" },
        { colTitle: "تاریخ ثبت", colName: "PRegisterDate" },
        { colTitle: "شماره ثبت", colName: "PRegisterDate" },
        { colTitle: "فرستنده/گیرنده", colName: "CustomerName" },
        { colTitle: "ثبت کننده", colName: "RegisterByName" },
        { colTitle: "وضعیت", colName: "MessageStatusName" }
    ]
    const tableRowButtons = [
        { title: "نمایش نامه", type: "show", className: "group-Btn-smalll btn-secondary", onclick: rowClick, showCondition: () => isMobile },
        {
            title: "حذف نامه", type: "delete", className: "group-Btn-smalll btn-danger", onclick: (item) => {
                dispatch(setDialog({
                    status: 'show',
                    arrayBtn: ['yes', 'no'],
                    dialogTitle: 'حذف نامه',
                    dialogText: 'آیا از حذف مطمئن هستید؟',
                    okOperation: () => deleteMsg(item)
                }))
            }
        }

    ]
    function showHideFilter(hide) {
        const divFilters = document.getElementById("divFilters");
        if (hide) {
            divFilters.classList.add("hiddenRow");
            setShowFilter(false);
        }
        else {
            divFilters.classList.remove("hiddenRow");
            setShowFilter(true);
        }
    }
    function clearFilters() {
        frmFilters.current.reset();
        setDateFilters({});
        dispatch(searchMessages({ Take: 10, Skip: 0 }));
    }
    function search(data) {
        const mdFrom = document.getElementsByName("MessageDateFrom")[0].value;
        if (mdFrom !== "") {
            data.MessageDateFrom = dateFilters.MessageDateFrom;
        }
        else {
            dateFilters.MessageDateFrom = null;
        }
        const mdTo = document.getElementsByName("MessageDateTo")[0].value;
        if (mdTo !== "") {
            data.MessageDateTo = dateFilters.MessageDateTo;
        }
        else {
            dateFilters.MessageDateTo = null;
        }
        const rdFrom = document.getElementsByName("RegisterDateFrom")[0].value;
        if (rdFrom !== "") {
            data.RegisterDateFrom = dateFilters.RegisterDateFrom;
        }
        else {
            dateFilters.RegisterDateFrom = null;
        }
        const rdTo = document.getElementsByName("RegisterDateTo")[0].value;
        if (rdTo !== "") {
            data.RegisterDateTo = dateFilters.RegisterDateTo;
        }
        else {
            dateFilters.RegisterDateTo = null;
        }
        data.Skip = 0;
        dispatch(searchMessages(data));
    }
    function rowClick(item) {
        if (item.ctrlIsDown) {
            window.open(`/Office/AddEditInterOfficeMessage/${item.MessageType}/${item.ID}`);
        }
        else {
            history.push(`/Office/AddEditInterOfficeMessage/${item.MessageType}/${item.ID}`)
        }
    }
    function deleteMsg(row) {
        const onDelete = (res) => {
            if (res.Data) {
                dispatch(searchMessages(filterData));
            }
            else if (res.Error) {
                setErrorDialog(dispatch, res.Error, "حذف نامه اداری");
            }
        }
        deleteMessage(row.ID, onDelete)
    }
    useEffect(() => {
        document.body.classList = "notMain";
        document.title = "بی همتا-اداری";
        getMessagePriorityList(setPriorityList);
        getMessageStatusList(setStatusList);
    }, [])
    return (
        <div className="container-fluid mt-1">
            <br />
            <Card>
                <Card.Header className="headerStyle">
                    <FontAwesomeIcon icon={faEnvelopeOpen} size="lg" />&nbsp;
                    جستجوی نامه های اداری
                </Card.Header>
                <Card.Body className="bodyStyle">
                    <form readOnly onSubmit={handleSubmit(search)} ref={frmFilters}>
                        <Row id="divFilters" className="rowBorder">
                            <div className="rowTitle">
                                فیلترهای جستجو
                                &nbsp;
                                {showFilter && <EyeSlashFill size={20} className="hoverIcon" style={{ cursor: "pointer", color: "#ca237e" }} onClick={() => showHideFilter(true)} />}
                                {!showFilter && <EyeFill size={20} className="hoverIcon" style={{ cursor: "pointer", color: "#ca237e" }} onClick={() => showHideFilter(false)} />}
                                {showFilter && <FontAwesomeIcon icon={faBroom} size="lg" style={{ cursor: "pointer", color: "#007e80" }} onClick={clearFilters} />}
                            </div>
                            <Col md={2} className="form-group">
                                <label>تاریخ نامه از:</label>
                                <DatePicker isGregorian={false} timePicker={false} className="form-control" name="MessageDateFrom"
                                    value={dateFilters.MessageDateFrom ? momenJalaali(dateFilters.MessageDateFrom) : null}
                                    onChange={value => setDateFilters({ ...dateFilters, MessageDateFrom: value.local("en").format("YYYY-MM-DD") })} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>تاریخ نامه تا:</label>
                                <DatePicker isGregorian={false} timePicker={false} className="form-control" name="MessageDateTo"
                                    value={dateFilters.MessageDateTo ? momenJalaali(dateFilters.MessageDateTo) : null}
                                    onChange={value => setDateFilters({ ...dateFilters, MessageDateTo: value.local("en").format("YYYY-MM-DD") })} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>تاریخ ثبت از:</label>
                                <DatePicker isGregorian={false} timePicker={false} className="form-control" name="RegisterDateFrom"
                                    value={dateFilters.RegisterDateFrom ? momenJalaali(dateFilters.RegisterDateFrom) : null}
                                    onChange={value => setDateFilters({ ...dateFilters, RegisterDateFrom: value.local("en").format("YYYY-MM-DD") })} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>تاریخ ثبت تا:</label>
                                <DatePicker isGregorian={false} timePicker={false} className="form-control" name="RegisterDateTo"
                                    value={dateFilters.RegisterDateTo ? momenJalaali(dateFilters.RegisterDateTo) : null}
                                    onChange={value => setDateFilters({ ...dateFilters, RegisterDateTo: value.local("en").format("YYYY-MM-DD") })} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>موضوع: </label>
                                <Form.Control name="Subject" ref={register({})} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>فرستنده/گیرنده: </label>
                                <Form.Control name="CustomerName" ref={register({})} defaultValue={filterData?.CustomerName ?? ""} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>اولویت: </label>
                                {Array.isArray(priorityList?.Data ?? "") ?
                                    <select className="form-control" ref={register({})} name="Priority" defaultValue={filterData?.Priority ?? ""}>
                                        <option value="">انتخاب کنید</option>
                                        {priorityList.Data.map((item, i) =>
                                            <option value={item.ID} key={i}>{item.InfoName}</option>)
                                        }
                                    </select> :
                                    <div className="form-control">
                                        <Loader type="BallTriangle" width={20} height={20} color="#bb1370" />
                                    </div>
                                }
                            </Col>
                            <Col md={2} className="form-group">
                                <label>شماره نامه: </label>
                                <Form.Control name="RealNumber" ref={register({})} defaultValue={filterData?.RealNumber ?? ""} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>شماره ثبت: </label>
                                <Form.Control name="RegisterNumber" ref={register({})} defaultValue={filterData?.RegisterNumber ?? ""} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>ثبت کننده: </label>
                                <Form.Control name="RegisteredByName" ref={register({})} defaultValue={filterData?.RegisteredByName ?? ""} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>وضعیت: </label>
                                {Array.isArray(statusList?.Data ?? "") ?
                                    <select className="form-control" ref={register({})} name="Priority" defaultValue={filterData?.MessageStatus ?? ""}>
                                        <option value="">انتخاب کنید</option>
                                        {statusList.Data.map((item, i) =>
                                            <option value={item.ID} key={i}>{item.InfoName}</option>)
                                        }
                                    </select> :
                                    <div className="form-control">
                                        <Loader type="BallTriangle" width={20} height={20} color="#bb1370" />
                                    </div>
                                }
                            </Col>
                            <Col md={2} className="form-group">
                                <label>وارده/صادره: </label>
                                <select className="form-control" name="MessageType" ref={register({})} defaultValue={filterData?.MessageType ?? ""}>
                                    <option value="">انتخاب کنید</option>
                                    <option value="In">وارده</option>
                                    <option value="Out">صادره</option>
                                </select>
                            </Col>
                            <Col md={2} className="form-group">
                                <label>تعداد در صفحه: </label>
                                <select className="form-control" name="Take" ref={register({})} defaultValue={filterData?.Take ?? 10}>
                                    <option value={10}>10</option>
                                    <option value={20}>20</option>
                                    <option value={50}>50</option>
                                    <option value={100}>100</option>
                                    <option value={0}>همه ردیف ها</option>
                                </select>
                            </Col>
                        </Row>
                        <Button className="group-Btn mt-1" variant="secondary" type="submit"><Search size={17} />&nbsp;جستجوی نامه</Button>
                    </form>
                    <BihamtaTable columns={tableCols} rowButtons={tableRowButtons} reducerName="CommonReducer" objectName="interOfficeMessageList" hasPaging={true}
                        style={{ whiteSpace: "nowrap" }} rowClick={rowClick} filterData={filterData} searchMethod={(data) => dispatch(searchMessages(data))} />
                </Card.Body>
            </Card>
        </div>)
}
export default SearchInterOfficeMessages;